import { createApi } from "@reduxjs/toolkit/dist/query/react";
// import { defautBaseQuery } from "../../utils/API/fetchBaseQuery";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const departmentAPI = createApi({
    reducerPath: "departmentAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //** List API */
        getDepartments: builder.mutation({
            query: (userQuery) => ({
                url: '/Department/GetDepartments',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Add  API */ 
        addDepartment: builder.mutation({
            query: (Details) => ({
                url: '/Department/AddDepartment',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** GetById API */
        getDepartmentById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Department/GetDepartmentById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['Department'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  Update API */
        updateDepartment: builder.mutation({
            query: (Details) => ({
                url: '/Department/UpdateDepartment',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['Department'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Delete API */
        deleteDepartment: builder.mutation({
            query: (id) => ({
                url: `/Department/DeleteDepartment/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getDepartment: builder.query({
            query: () => ({
                url: encryptQueryString(`/Department/GetDepartment`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
})

export const {
    useGetDepartmentsMutation,
    useAddDepartmentMutation,
    useLazyGetDepartmentByIdQuery,
    useUpdateDepartmentMutation,
    useDeleteDepartmentMutation,
    useLazyGetDepartmentQuery
} = departmentAPI

export default departmentAPI;